module.exports = __webpack_public_path__ + "static/media/burlingame2.ee338f97.jpg";